var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SequenceLabel',{staticClass:"ui-signingSequence-labels-SequentialLabel",attrs:{"label":_vm.$t('signingSequence.ui.labels.sequential'),"for":_vm.forId}},[_vm._v("\n  "+_vm._s(_vm.$t('signingSequence.ui.explainers.sequential'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }